import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'

export const useUploadHeader = () => {
  const [uploadHeader, setUploadHeader] = useState(false)
  const { deleteNewUploadHeader, getNewUploadHeaders } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Upload Header', 'ALL_UPLOAD_HEADERS', 'GET_ALL_UPLOAD_HEADERS')
  const {
    UPLOAD_HEADER: { GET_ALL_UPLOAD_HEADERS, ADD_UPLOAD_HEADER, EDIT_UPLOAD_HEADER, GET_UPLOAD_HEADER, DELETE_MANY_UPLOAD_HEADER },
  } = API_URL

  const getAllUploadHeader = async (dto = {}) => {
    GET_ALL(GET_ALL_UPLOAD_HEADERS, setPaginate, getNewUploadHeaders, dto)
  }

  const addUploadHeader = (dto) => {
    ADD(ADD_UPLOAD_HEADER, dto)
  }

  const updateUploadHeader = (dto) => {
    UPDATE(EDIT_UPLOAD_HEADER, dto)
  }

  const getUploadHeader = (dto) => {
    // GET_ALL(GET_UPLOAD_HEADER, setUploadHeader, dto.uploadHeaderId)
    GET_SINGLE_DATA(GET_ALL_UPLOAD_HEADERS, setUploadHeader, dto)
  }

  const deleteManyUploadHeader = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_UPLOAD_HEADER, dto, 'uploadHeaderId', setSelected, deleteNewUploadHeader, 'GET_ALL_UPLOAD_HEADERS')
  }

  return {
    addUploadHeader,
    getAllUploadHeader,
    getUploadHeader,
    uploadHeader,
    updateUploadHeader,
    deleteManyUploadHeader,
    loading,
    paginate,
  }
}
